import { render } from "./PositionAndDeviceTips.vue?vue&type=template&id=ab25b9ec"
import script from "./PositionAndDeviceTips.vue?vue&type=script&lang=js"
export * from "./PositionAndDeviceTips.vue?vue&type=script&lang=js"

import "./PositionAndDeviceTips.vue?vue&type=style&index=0&id=ab25b9ec&lang=scss"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__